/*
 * Copyright (c) 2021.
 * Md Naimul Hasan
 * naim886@gmail.com
 * 01719123886
 * www.naimbd.com
 */

import React from "react";

const Footer = () =>{
    return(
        <>
            <footer className="py-2 bg-light mt-auto">
                <div className="container-fluid px-4">
                    <div className="d-flex align-items-center justify-content-between small">
                        <div className="text-muted">Copyright &copy; Mega Hot Mop {new Date().getFullYear()}</div>
                        <div>
                            <a href="https://megahotmop.com/" rel="noreferrer" target={'_blank'}>Mega Hot Mop</a>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}
export default Footer